import * as React from 'react';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SvgNewCustomer = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "12 12 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M9.423 4C7.917 3.992 6.451 5.443 7.12 7.245H4.594A1.593 1.593 0 0 0 3 8.839v1.595a.797.797 0 0 0 .797.797h7.172V8.839h1.594v2.392h7.172a.797.797 0 0 0 .797-.797V8.838a1.595 1.595 0 0 0-1.594-1.594h-2.526c.932-2.607-2.574-4.449-4.192-2.2l-.454.605-.454-.622c-.502-.71-1.196-1.02-1.889-1.028Zm-.048 1.65c.71 0 1.068.861.566 1.363-.502.503-1.363.144-1.363-.566a.797.797 0 0 1 .797-.797Zm4.782 0c.709 0 1.068.861.566 1.363-.503.503-1.363.144-1.363-.566a.797.797 0 0 1 .797-.797Zm-10.36 6.378v6.378A1.595 1.595 0 0 0 5.39 20h12.75a1.594 1.594 0 0 0 1.594-1.594v-6.378h-7.172v6.378h-1.594v-6.378H3.797Z",
  transform: "translate(10 9)",
  style: {
    fill: "currentColor"
  }
}));

export { SvgNewCustomer as default };
